import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/$owner/agents')({
  component: () => <Outlet />,
});
